import styled from 'styled-components';
import {
  Icon as IconSemantic,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Header = styled.div`
  display: flex;
`;

const DayBoxHeader = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 45px;
  margin: 7px;
  color: ${({ theme }) => theme.color.textHeader};
  font-size: ${({ theme }) => theme.fontSize.textHeader};
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 915px) {
    font-size: ${({ theme }) => theme.fontSize.text};
  }

  @media (max-width: 830px) {
    font-size: 13px;
  }

`;

const Icon = styled(IconSemantic)`
 &&& {
   display: inline;
   margin: 0;
  }

  :hover {
    cursor: pointer;
  };
`;

const DateTextWrapper = styled.div``;

const DayName = styled(TextLayoutComponent)`
  font-weight: 500;
  color: ${({ theme }) => theme.color.textHeader};
  font-size: ${({ theme }) => theme.fontSize.textHeader};

  @media (max-width: 915px) {
    font-size: ${({ theme }) => theme.fontSize.text};
  }

  @media (max-width: 830px) {
    font-size: 13px;
  }
`;

const ContainerIcon = styled.div`
  position: absolute;
  ${({ left }) => (left ? 'left: -20px;' : '')}
  ${({ right }) => (right ? 'right: -20px;' : '')}
`;

export {
  ContainerIcon,
  DayBoxHeader,
  DayName,
  Header,
  Icon,
  DateTextWrapper,
};
